import { z } from "zod";
import * as e from "./EAppValidation"

const AppValidationTestCase = z.object({
  title: z.string().nullish(),
  message: z.string().nullish(),
  artifacts: z.object({
    filePath: z.string().optional().nullish(),
    docsUrl: z.string().optional().nullish(),
    policyNumber: z.string().optional().nullish(),
    policyLinkUrl: z.string().optional().nullish(),
    recommendation: z.string().optional().nullish(),
  }).optional(),
});

export const AppValidationItem = z.object({
  id: z.string().optional().nullish(),
  appValidationId: z.string().optional().nullish(),
  createdAt: z.string().nullish(),
  updatedAt: z.string().nullish(),
  appId: z.string().nullish(),
  appVersion: z.string().nullish(),
  manifestVersion: z.string().nullish(),
  status: z.nativeEnum(e.ValidationStatus),
  validationResults: z.object({
    successes: z.array(AppValidationTestCase).optional(),
    warnings: z.array(AppValidationTestCase).optional(),
    failures: z.array(AppValidationTestCase).optional(),
    skipped: z.array(AppValidationTestCase).optional(),
  }).optional().nullable()
});

export const AppValidationList = z.object({
  appValidations: z.array(AppValidationItem).nullable(),
  continuationToken: z.string().optional().nullish(),
});


export type IAppValidationItem = z.infer<typeof AppValidationItem>;
export type IAppValidationList = z.infer<typeof AppValidationList>;
export type IAppValidationTestCase = z.infer<typeof AppValidationTestCase>;
